const single = state => state.single
const pageIsLoading = state => state.pageIsLoading
const homepage = state => state.homepage
const post = state => state.post
const postIsLoading = state => state.postIsLoading
const posts = state => state.posts
const postsIsLoading = state => state.postsIsLoading
const pageTitle = state => state.pageTitle

export {
  single,
  pageIsLoading,
  homepage,
  posts,
  postsIsLoading,
  post,
  postIsLoading,
  pageTitle
}
